/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Colors, Typography } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import { MEDIA_MIN_WIDTH } from '../../../constants';
import { ReactNode } from 'react';
import { useDateTime } from '../utils';

const Styles = labelStyles('AgendaGroup', {
  root: css({ maxWidth: '1210px', margin: '0 auto' }),
  topBorder: css({
    position: 'sticky',
    top: 0,
    height: '1px',
    backgroundColor: Colors.earth,
    margin: '-1px 20px 0px 20px',
    maxWidth: '1210px',
    zIndex: 2,
  }),
  container: (borderBottom: boolean) =>
    css({
      borderRight: `1px solid ${Colors.earth}`,
      borderLeft: `1px solid ${Colors.earth}`,
      color: Colors.earth,
      margin: '0px 20px',
      backgroundColor: Colors.white,
      ...(borderBottom && { borderBottom: `1px solid ${Colors.earth}` }),
      [MEDIA_MIN_WIDTH.large]: {
        display: 'flex',
      },
    }),

  headingContainer: css({
    minWidth: '200px',
    borderBottom: `1px solid ${Colors.earth}`,
    position: 'sticky',
    top: '60px',
    zIndex: 1,
    backgroundColor: Colors.white,
    [MEDIA_MIN_WIDTH.medium]: {
      top: '80px',
    },
    [MEDIA_MIN_WIDTH.large]: {
      borderBottom: 'none',
      borderRight: `1px solid ${Colors.earth}`,
    },
  }),
  heading: css({
    padding: '13px 0px 13px 14px',
    fontFamily: Typography.heading.fontFamily,
    fontSize: '24px',
    fontWeight: 500,
    letterSpacing: '1px',
    lineHeight: '32px',
    [MEDIA_MIN_WIDTH.medium]: {
      padding: '16px 0px 16px 30px',
      fontSize: '32px',
      lineHeight: '110%',
      fontWeight: 500,
      letterSpacing: '1.5px',
    },
    [MEDIA_MIN_WIDTH.large]: {
      position: 'sticky',
      fontSize: '24px',
      top: '60px',
      padding: '27px 0px 11px 17.5px',
      lineHeight: '35.2px',
      [MEDIA_MIN_WIDTH.medium]: {
        top: '80px',
      },
    },
  }),
  content: css({
    width: '100%',
  }),
});
type Props = {
  time: string;
  amPM: 'am' | 'pm';
  children: ReactNode;
  borderBottom: boolean;
};

export function AgendaGroup({ children, borderBottom, time }: Props) {
  const { longTime } = useDateTime(time);

  return (
    <div css={Styles.root}>
      <div css={Styles.topBorder} />
      <div css={Styles.container(borderBottom)}>
        <div css={Styles.headingContainer}>
          <h2 css={Styles.heading}>{longTime}</h2>
        </div>
        <div css={Styles.content}>{children}</div>
      </div>
    </div>
  );
}
